import classNames from "classnames";
import { bgStyles, heightStyles } from "../styles";

export function Divider() {
  return <div className={classNames(heightStyles.height006, bgStyles.neutral300)} />;
}
